'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRouter = require('react-router');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);
var _components = require('../../../components');

var _analyticsManager = require('../../../utils/analytics/analyticsManager');
var _analyticsConstants = require('../../../utils/analytics/analyticsConstants');
var _formatPhoneNumber = require('../../../utils/formatPhoneNumber');
var _modifyImageLink = require('../../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _constants = require('../../../constants');
var _constructLink = require('../../../helpers/constructLink');

var _Contacts = require('./Contacts.scss');var _Contacts2 = _interopRequireDefault(_Contacts);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Helpers
// Styles
var Contacts = function (_Component) {_inherits(Contacts, _Component);function Contacts() {var _temp, _this, _ret;_classCallCheck(this, Contacts);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      isTooltipShown: false,
      contactsAreOpen: {
        primary: false,
        secondary: false },

      phoneIsRevealed: {
        primary: false,
        secondary: false } }, _this.



    handleShowPhone = function () {var _Object$assign;var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'primary';var
      propertyId = _this.props.data.propertyId;

      (0, _analyticsManager.trackGTM)({ name: _analyticsConstants.eventCategory.contactViews });
      _this.props.incrementClicks({ propertyId: propertyId, action: _constants.analyticsEventAction.SHOW_NUMBER });
      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.propertyDetails, _analyticsConstants.eventAction.show, _analyticsConstants.eventLabel.phoneNumber);
      return _this.setState({
        phoneIsRevealed: Object.assign({},
        _this.state.phoneIsRevealed, (_Object$assign = {}, _Object$assign[
        type] = true, _Object$assign)) });


    }, _this.

    printInfo = function () {return _this.props.showPrintPage();}, _this.

    shouldShowEmail = function (email) {return false;}, _this.

    handleOpenContact = function (contact, status) {
      var contactsAreOpen = Object.assign({}, _this.state.contactsAreOpen);
      contactsAreOpen[contact] = status;
      _this.setState({ contactsAreOpen: contactsAreOpen });
    }, _this.

    renderOnMapTitle = function () {
      var title = _this.props.translate('propertyDetails', 'contacts', 'onMapTitle').split('%s');
      title.splice(1, 0, _react2.default.createElement('span', { key: _Contacts2.default.logoTitle, className: _Contacts2.default.logoTitle }, 'OnMap'));
      return title;
    }, _this.

    renderContactButton = function () {var _this$props =
      _this.props,translate = _this$props.translate,isForeign = _this$props.isForeign,primary = _this$props.contacts.primary;

      if (isForeign) {
        return (
          _react2.default.createElement('button', {
              type: 'button',
              className: (0, _classnames2.default)(_Contacts2.default.hideText, _Contacts2.default.scrollButton),
              onClick: _this.props.scrollToForm },

            translate('propertyDetails', 'contacts', 'writeToSeller')));


      }
      return _this.state.phoneIsRevealed.primary ?
      _react2.default.createElement('div', { className: (0, _classnames2.default)(_Contacts2.default.hideText, _Contacts2.default.textRevealed) },
        (0, _formatPhoneNumber.formatPhoneNumber)((0, _formatPhoneNumber.clearPhoneNumber)(primary.phone))) :


      _react2.default.createElement('div', { className: _Contacts2.default.hideText, onClick: function onClick() {return _this.handleShowPhone('primary');} },
        _react2.default.createElement('span', { className: (0, _classnames2.default)('icon icon-phone-fill', _Contacts2.default.iconsIndent) }),
        translate('propertyDetails', 'contacts', 'showNumber'));


    }, _this.















































    renderCompanyName = function (companyName) {return (
        _react2.default.createElement('span', { className: (0, _classnames2.default)(_Contacts2.default.textAlignment, _Contacts2.default.textAlignment) }, companyName));}, _this.

    renderCompanyLink = function (content) {var
      agencyId = _this.props.realEstateData.agencyId;

      return (
        _react2.default.createElement(_reactRouter.Link, {
            to: (0, _constructLink.constructCompanyLink)(_this.props.locale, agencyId),
            className: _Contacts2.default.textAlignment },

          content));


    }, _this.

    renderLogo = function (logoLink) {
      var logo =
      _react2.default.createElement('div', {
        className: _Contacts2.default.realEstateIcon,
        style: {
          backgroundImage: 'url(' + (0, _modifyImageLink2.default)(logoLink, _constants.imageModifierTypes.LOGO) + ')' } });




      return _this.renderCompanyLink(logo);
    }, _temp), _possibleConstructorReturn(_this, _ret);} // email && !isTemporaryEmail(email);
  Contacts.prototype.renderContact = function renderContact() {if (!this.props.contacts.primary || (0, _isEmpty2.default)(this.props.contacts.primary)) {return null;}var _props$contacts$prima = this.props.contacts.primary,name = _props$contacts$prima.name,email = _props$contacts$prima.email,phone = _props$contacts$prima.phone;return _react2.default.createElement('div', { className: (0, _classnames2.default)(_Contacts2.default.contactsBlock, _Contacts2.default.openBlock), key: 'contact-primary' }, _react2.default.createElement('div', { className: _Contacts2.default.contactRow }, _react2.default.createElement('div', null, _react2.default.createElement('div', { className: (0, _classnames2.default)('icon icon-user', _Contacts2.default.iconsIndent, _Contacts2.default.textAlignment) }), _react2.default.createElement('span', { className: _Contacts2.default.textAlignment }, name))), this.renderContactButton(), this.state.phoneIsRevealed.primary && !this.props.isPreview && _react2.default.createElement('span', { className: _Contacts2.default.onMapTitle }, this.renderOnMapTitle()));};Contacts.prototype.renderShareButton = function renderShareButton() {var _this2 = this;return _react2.default.createElement('button', { className: (0, _classnames2.default)(_Contacts2.default.button, _Contacts2.default.buttonPrint), onClick: function onClick() {return _this2.setState({ isTooltipShown: !_this2.state.isTooltipShown });} }, _react2.default.createElement('span', { className: _Contacts2.default.buttonContent }, _react2.default.createElement('span', null, this.props.translate('propertyDetails', 'contacts', 'share')), '\xA0\xA0', _react2.default.createElement('span', { className: 'icon icon-contacts-share' })));};Contacts.prototype.
  render = function render() {var _cx,_this3 = this,_cx2;var _props =
    this.props,data = _props.data,translate = _props.translate,isPreview = _props.isPreview;var _props$realEstateData =
    this.props.realEstateData,isAgent = _props$realEstateData.isAgent,companyName = _props$realEstateData.companyName,logo = _props$realEstateData.logo;var
    isTooltipShown = this.state.isTooltipShown;
    var agencyPageExist = !!(0, _get2.default)(this.props, 'contacts.primary.agency_page');
    var secondaryPhone = !!(0, _get2.default)(this.props, 'contacts.secondary.phone');

    return (
      _react2.default.createElement('div', { className: _Contacts2.default.contactsContainer },

        isAgent ?
        _react2.default.createElement('div', { className: (0, _classnames2.default)(_Contacts2.default.agentsBlock, (_cx = {}, _cx[_Contacts2.default.noCompanyName] = !companyName, _cx)) },
          _react2.default.createElement('div', { className: _Contacts2.default.agentsTitle },
            _react2.default.createElement('span', { className: (0, _classnames2.default)(_Contacts2.default.title, _Contacts2.default.smallIndent) }, translate('propertyDetails', 'contacts', 'agentTitle')),

            companyName &&
            _react2.default.createElement('div', { className: (0, _classnames2.default)(_Contacts2.default.contactRow, _Contacts2.default.companyRow) },
              _react2.default.createElement('span', { className: (0, _classnames2.default)('icon icon-contacts-office', _Contacts2.default.iconsIndent, _Contacts2.default.textAlignment) }),
              this.renderCompanyLink(companyName))),




          logo && this.renderLogo(logo, agencyPageExist)) :


        _react2.default.createElement('span', { className: _Contacts2.default.title }, translate('propertyDetails', 'contacts', 'title')),


        [
        this.renderContact(),
        !!this.props.contacts.secondary && secondaryPhone &&
        _react2.default.createElement('div', { className: _Contacts2.default.delimiter, key: 'delimiter' }),

        !!this.props.contacts.secondary && secondaryPhone &&
        _react2.default.createElement(_components.HiddenContact, {
          contact: this.props.contacts.secondary,
          openContactHandler: function openContactHandler(status) {return _this3.handleOpenContact('secondary', status);},
          isShownPhone: this.state.phoneIsRevealed.secondary,
          translate: this.props.translate('propertyDetails'),
          key: 'secondary-contact',
          phoneButtonClassName: (0, _classnames2.default)(_Contacts2.default.hideText, (_cx2 = {}, _cx2[
          _Contacts2.default.textRevealed] = this.state.phoneIsRevealed.secondary, _cx2)),

          phoneButtonOnClick: function phoneButtonOnClick() {return _this3.handleShowPhone('secondary');} })],




        this.state.phoneIsRevealed.secondary && this.state.contactsAreOpen.secondary && !isPreview &&
        _react2.default.createElement('span', { className: _Contacts2.default.onMapTitle }, this.renderOnMapTitle()),


        !!data.propertyId &&
        _react2.default.createElement('div', { className: _Contacts2.default.buttonsLine },
          _react2.default.createElement(_components.ShareBlock, {
            locale: this.props.locale,
            translate: this.props.translate,
            sharingData: data,
            isTooltipShown: isTooltipShown,
            copyLinkTitle: '' + translate('copyLink'),
            emailTitle: '' + translate('propertyDetails', 'contacts', 'email') }),


          _react2.default.createElement('button', { className: (0, _classnames2.default)(_Contacts2.default.button, _Contacts2.default.buttonPrint), onClick: this.printInfo },
            this.props.printPageShown ?
            _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', _Contacts2.default.spinner) }) :

            _react2.default.createElement('span', { className: _Contacts2.default.buttonContent },
              _react2.default.createElement('span', null, translate('propertyDetails', 'contacts', 'print')), '\xA0\xA0',
              _react2.default.createElement('span', { className: 'icon icon-contacts-print' }))))));







  };return Contacts;}(_react.Component);exports.default = Contacts;


Contacts.propTypes = {
  locale: _propTypes2.default.string,
  data: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  realEstateData: _propTypes2.default.object,
  contacts: _propTypes2.default.object,
  isPreview: _propTypes2.default.bool,
  showPrintPage: _propTypes2.default.func,
  scrollToForm: _propTypes2.default.func,
  incrementClicks: _propTypes2.default.func,
  printPageShown: _propTypes2.default.bool,
  isForeign: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/Contacts/Contacts.js
// module id = 1228
// module chunks = 0